if (!customElements.get('free-shipping')) {
  customElements.define(
    'free-shipping',
    class FreeShipping extends HTMLElement {
      constructor() {
        super();
        this.cartTotal = this.dataset.cartTotal || 0;
        this.freeShippingThreshold = this.dataset.freeShippingThreshold || 0;
        this.message = this.dataset.message || '';
        this.messageSomeAmmount = this.dataset.messageSomeAmmount || '';
        this.messageCompleted = this.dataset.messageCompleted || '';
        this.compiledMessage = '';
        this.currencySymbol = this.dataset.currencySymbol || '';
        this.roundAmount = this.dataset.roundAmount === 'true';
        this.observer = new MutationObserver(this.handleMutations.bind(this));
        this.progressBar = this.querySelector('progress-bar');
      }

      connectedCallback() {
        this.setMessage(this.getAmountLeft(this.cartTotal));
        this.addMessage();
        this.addEventListeners();
        this.observeAttributes();
        this.updateOtherFreeShippingElements();
      }

      disconnectedCallback() {
        this.removeEventListeners();
        this.observer.disconnect();
      }

      addEventListeners() {
        this.addEventListener('updateFreeShipping', this.updateFreeShipping.bind(this));
      }

      removeEventListeners() {
        this.removeEventListener('updateFreeShipping', this.updateFreeShipping.bind(this));
      }

      observeAttributes() {
        this.observer.observe(this, { attributes: true, attributeFilter: ['data-cart-total'] });
      }

      handleMutations(mutations) {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-cart-total') {
            this.cartTotal = this.dataset.cartTotal;
            this.updateContent();
          }
        }
      }

      getAmountLeft(total) {
        const currencyRate = 1; // Shopify.currency.rate;
        let amountLeftToSpend = (this.freeShippingThreshold) / 100;
        amountLeftToSpend = Math.round(amountLeftToSpend * 100) / 100;
        amountLeftToSpend = this.roundAmount ? Math.round(amountLeftToSpend) : amountLeftToSpend;
        return amountLeftToSpend <= 0 ? 0 : amountLeftToSpend + this.currencySymbol;
      }

      setMessage(amountLeftToSpend) {
        if (this.cartTotal === 0) {
          this.compiledMessage = this.message;
        } else if (this.cartTotal >= this.freeShippingThreshold) {
          this.compiledMessage = this.messageCompleted;
        } else {
          this.compiledMessage = this.messageSomeAmmount.replace('{{ amount }}', amountLeftToSpend);
        }
      }

      addMessage() {
        const node = document.createElement('p');
        node.innerText = this.compiledMessage;
        this.prepend(node);
      }

      updateContent() {
        this.setMessage(this.getAmountLeft(this.cartTotal));
        this.querySelector('p').innerText = this.compiledMessage;
        this.progressBar.setProgress(this.barPercentage(this.cartTotal));
      }

      barPercentage(cartTotal) {
        return ((cartTotal / this.freeShippingThreshold) * 100).toFixed(2);
      }

      updateFreeShipping(event) {
        this.cartTotal = event.detail.cartTotal;
        this.updateContent();
      }

      updateOtherFreeShippingElements() {
        const otherElements = document.querySelectorAll('free-shipping');
        otherElements.forEach(element => {
          if (element !== this) {
            element.setAttribute('data-cart-total', this.cartTotal);
          }
        });
      }
    }
  );
}

if (!customElements.get('progress-bar')) {
  customElements.define(
    'progress-bar',
    class ProgressBar extends HTMLElement {
    constructor() {
      super();

      this.progress = parseInt(this.dataset.value);
    }

    updateProgress() {
      this.style.setProperty('--progress', this.progress + '%');
    }

    setProgress(newProgress) {
      this.progress = Math.min(newProgress, 100); // Cap the progress at 100%
      this.updateProgress();
    }
  });
}
